import { I18nLink } from '@stape-io/promo-shared-content/components';
import clsx from 'clsx';

import { SearchResults } from '@/lib/models/Search';
import { getTypeIcon } from '@/lib/utils/getTypeIcon';
import { ResultSearchItemWrapper } from '@/shared/SearchDropdown/components/ResultSearchItemWrapper';
import { formatSearchResultPath } from '@/lib/utils/formatSearchResultPath';
import { highlightMatch } from '@/lib/utils/highlightMatch';

import styles from './SearchDropdownResults.module.scss';

interface SearchDropdownResultsProps {
  query: string;
  results: SearchResults;
  handleClickShowMore: () => void;
  t: (key: string, options?: any) => string;
  onClose?: () => void;
}

export function SearchDropdownResults({ query, onClose, results, handleClickShowMore, t }: SearchDropdownResultsProps) {
  return (
    <div className={styles.contentSearchList}>
      {results.hits.map((hit) => (
        <ResultSearchItemWrapper url={hit.url} key={hit.objectID} onClose={onClose}>
          <div className={styles.resultSearchItem}>
            <div className={styles.wrappIconLink}>
              <div>{getTypeIcon(hit.objectType, 24)}</div>
              <div>
                <h5 className={clsx(styles.title, 'h5')}>{highlightMatch({ text: hit.title, query })}</h5>
                <p className={clsx(styles.resultPath, 'text-sm')}>
                  {formatSearchResultPath(`${t(hit.objectType)}`, hit.objectCategory, hit.objectSubCategory)}
                </p>
              </div>
            </div>
            <div className={styles.arrow}>→</div>
          </div>
        </ResultSearchItemWrapper>
      ))}

      {results.count > 20 && (
        <I18nLink href={`/helpdesk/search?q=${query}`} className={clsx(styles.showAllButton, 'h5')} onClick={handleClickShowMore}>
          {t('showAllResults')}
        </I18nLink>
      )}
    </div>
  );
}
